import { createSlice } from "@reduxjs/toolkit";
import * as Actions from "../actions";
import { InitialState } from "./models";
import { dataKitColetaReducer } from "../reducers";

const initialState: InitialState = {
  dataKitColeta: {
    data: [],
    requestGetParams: {
      diretorios: [],
      dataInicial: "",
      dataFinal: "",
      nomeArquivo: "",
    },
    pagination: {
      page: 1,
      rowsPerPage: 15,
      totalPages: 0,
      totalItems: 0,
    },
    isLoading: false,
    isDownloading: false,
  },
  configTabs: {
    tabInView: 0,
    tabs: [
      {
        title: "Kit Coleta",
        index: 0,
        active: true,
        name: "kitColeta",
      },
    ],
  },
};

const kitColetaSlice = createSlice({
  name: "kitColetaApp/kitColeta",
  initialState,
  reducers: {
    changeTab: (state, action) => {
      state.configTabs.tabInView = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(Actions.getKitColeta.pending, (state) => {
      state.dataKitColeta.isLoading = true;
    });
    builder.addCase(Actions.getKitColeta.rejected, (state) => {
      state.dataKitColeta.isLoading = false;
    });
    builder.addCase(Actions.getKitColeta.fulfilled, dataKitColetaReducer);

    // Estados para o download de arquivos
    builder.addCase(Actions.getKitColetaDownloadFile.pending, (state) => {
      state.dataKitColeta.isDownloading = true;
    });
    builder.addCase(Actions.getKitColetaDownloadFile.fulfilled, (state) => {
      state.dataKitColeta.isDownloading = false;
    });
    builder.addCase(Actions.getKitColetaDownloadFile.rejected, (state) => {
      state.dataKitColeta.isDownloading = false;
    });
  },
});

export const { changeTab } = kitColetaSlice.actions;

export default kitColetaSlice.reducer;
